function SafeStringify(data) {
  if (typeof data === 'string') return data;
  if (Array.isArray(data) && data.length === 1) return SafeStringify(data[0]);
  else return JSON.stringify(data);
}
export default SafeStringify;
